import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "aspect-[1470/443] bg-gray-700" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex absolute inset-0 justify-center content-center items-center py-2 px-4 text-xs font-bold text-center text-white lg:py-12 lg:px-48 lg:text-3xl" }
const _hoisted_5 = { class: "inline-flex mt-2" }
const _hoisted_6 = ["onClick"]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    slides: null
  },
  setup(__props: any) {

const props = __props as {
  slides: {
    image: string,
    text: string
  }[]
}



const activeSlideClasses   = ['opacity-0'];
const inactiveSlideClasses = ['z-10', 'opacity-100'];

const activeSlideIndex = ref(0);
const lastSlideIndex   = props.slides.length - 1;

function getSlideClass(slideIndex: any) {
  if (slideIndex === activeSlideIndex.value) {
    return activeSlideClasses;
  }
  return inactiveSlideClasses;
}

const interval = setInterval(() => {
  if (activeSlideIndex.value < lastSlideIndex) {
    activeSlideIndex.value++;
  } else {
    activeSlideIndex.value = 0;
  }
}, 5000);

function changeSlide(index: any) {
  activeSlideIndex.value = index;
  clearInterval(interval);
}

function getDotsClass(index: any) {
  if (index === activeSlideIndex.value) {
    return 'bg-teal-300';
  }
  return 'bg-gray-400';
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slides, (slide, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass([getSlideClass(index), "absolute inset-0 z-0 transition-opacity duration-1000"])
          }, [
            _createElementVNode("img", {
              src: slide.image,
              alt: "bg",
              class: "w-full"
            }, null, 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, _toDisplayString(slide.text), 1)
            ])
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slides, (slide, index) => {
        return (_openBlock(), _createElementBlock("a", {
          key: index,
          href: "#",
          class: _normalizeClass([getDotsClass(index), "block p-2 mr-2 bg-teal-500 rounded-full hover:ring-2 hover:ring-cyan-300"]),
          onClick: _withModifiers(($event: any) => (changeSlide(index)), ["prevent"])
        }, null, 10, _hoisted_6))
      }), 128))
    ])
  ], 64))
}
}

})